import { render } from "./_formName.vue?vue&type=template&id=f27b90ec"
import script from "./_formName.vue?vue&type=script&lang=js"
export * from "./_formName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__